import { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import graphqlRequest from "../../../requestMethod";
import PaymentModal from "./PaymentModal";
import { load } from "@cashfreepayments/cashfree-js";
import PaymentSuccess from "./PaymentSuccess";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function BillingActionCell({ rowData }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rowClickedData, setRowClickedData] = useState();
  const [orderId, setOrderId] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);

  // console.log("rowData in action cell:", rowData);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  // console.log("rowData", rowData);
  const handleClick = () => {
    // console.log("rowData in handleClick:", rowData);
    setRowClickedData(rowData);
    // console.log("Clicked row data:", rowData); // ✅ row data aayega
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // console.log("rowData", rowData);
  // const creditLimit = rowClickedData?.branch?.creditLimit;
  // const utilizedLimit = rowClickedData?.branch?.utilizedLimit;

  const data = localStorage.getItem("auth");
  const token = JSON.parse(data)?.accessToken;

  const handleCreateOrder = async (
    paymentType,
    billOfSupplyTds,
    invoiceTaxTds,
    amountPayable
  ) => {
    try {
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            fabricate {
              createCashfreeOrder(
                amount: "${amountPayable}", 
                branchId:"${rowClickedData?.branch?.id}",
                mode: "${
                  paymentType === "full" ? "full_payment" : "partial_payment"
                }",
                billNumber:"${rowClickedData?.billNumber}", 
                billTds: "${billOfSupplyTds ? billOfSupplyTds : 0}", 
                invoiceTds: "${invoiceTaxTds}"
              ) {
                order_id
                payment_session_id
              }
            }
          }
        }
      `;

      const response = await graphqlRequest(query);
      // console.log("Cashfree createOrder response:", response);

      // TODO: Cashfree SDK integration here
      const createdOrderId =
        response.data.mutationWithAuth.fabricate.createCashfreeOrder.order_id;
      // setOrderId(
      //   response.data.mutationWithAuth.fabricate.createCashfreeOrder.order_id
      // );
      const sessionId =
        response.data.mutationWithAuth.fabricate.createCashfreeOrder
          .payment_session_id;
      setOrderId(createdOrderId);
      //  setSessionId(sessionId);
      await openCashfreeCheckout(sessionId);
    } catch (err) {
      console.error("Error creating order:", err);
    }
  };

 const openCashfreeCheckout = async (paymentSessionId) => {
   try {
    // console.log(
    //   "REACT_APP_CASHFREE_MODE",
    //   process.env.REACT_APP_CASHFREE_MODE
    // );
     const cashfree = await load({ mode: process.env.REACT_APP_CASHFREE_MODE });

     await cashfree.checkout({
       paymentSessionId,
       redirectTarget: "_self",
     });
   
   } catch (err) {
     console.error("Cashfree checkout failed", err);
   }
 };

const cashfreeAmountReceived = parseFloat(rowData?.cashfreeAmountReceived || 0) + parseFloat(rowData?.tdsBillOfSupplyDeduction || 0) + parseFloat(rowData?.tdsTaxInvoiceDeduction || 0);

  return (
    <>
      {/* {rowData?.status === "UNPAID" ||
      (rowData?.status !== "UNPAID" &&
        cashfreeAmountReceived < rowData?.amount) ? (
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          // sx={{ textTransform: "none", borderRadius: "8px" }}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            bgcolor: "#1976d2",
            color: "white",
            "&:hover": {
              bgcolor: "#1565c0", 
            },
          }}
        >
          Pay Now
        </Button>
      ) : (
        <Typography
          variant="body2"
          sx={{
            display: "inline-block",
            px: 2,
            py: 0.5,
            borderRadius: "8px",
            bgcolor: "grey.100",
            color: "success.dark",
            fontWeight: 600,
          }}
        >
          Success
        </Typography>

        
      )} */}

      {rowData?.status === "PAID" ? (
        <Typography
          variant="body2"
          sx={{
            display: "inline-block",
            px: 2,
            py: 0.5,
            borderRadius: "8px",
            bgcolor: "grey.100",
            color: "success.dark",
            fontWeight: 600,
          }}
        >
          Success
        </Typography>
      ) : parseFloat(rowData?.offlineBillDetails?.amountReceivedAgainstBill || 0) > 0 ? (
         <Typography
          variant="body2"
          sx={{
            display: "inline-block",
            px: 2,
            py: 0.5,
            borderRadius: "8px",
            bgcolor: "grey.100",
            color: "success.dark",
            fontWeight: 600,
          }}
        >
          Offline Paid
        </Typography>
      ): (
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            bgcolor: "#1976d2",
            color: "white",
            "&:hover": {
              bgcolor: "#1565c0",
            },
          }}
        >
          Pay Now
        </Button>
      )}

      <PaymentModal
        open={open}
        onClose={handleClose}
        rowClickedData={rowClickedData}
        handleCreateOrder={handleCreateOrder}
      />
    </>
  );
}
